import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconBroadcast } from '@tabler/icons-react';

import { useEnableRealTimeStats, useDisableRealTimeStats } from '../../../../api';
import { Platform } from '../../../../types';

import { ConfirmModal } from '@/components/Modals/Confirm';

type RealTimeStatsButtonProps = {
  isRealTimeStatsEnabled?: boolean;
  pageId: string;
  platform: Platform;
};

export const RealTimeStatsButton = ({
  pageId,
  isRealTimeStatsEnabled,
  platform,
}: RealTimeStatsButtonProps) => {
  const enableRealtimeStats = useEnableRealTimeStats();
  const disableRealtimeStats = useDisableRealTimeStats();

  if (isRealTimeStatsEnabled) {
    return (
      <Tooltip label="Disable Real Time New Dialogs Stats">
        <ActionIcon
          loading={disableRealtimeStats.isLoading}
          color="teal"
          radius="md"
          onClick={() =>
            NiceModal.show(ConfirmModal, {
              title: 'Disable Real Time New Dialogs Stats?',
              onSuccess: () => disableRealtimeStats.mutate({ pageId, platform }),
            })
          }
        >
          <IconBroadcast />
        </ActionIcon>
      </Tooltip>
    );
  }

  return (
    <Tooltip label="Enable Real Time New Dialogs Stats">
      <ActionIcon
        loading={enableRealtimeStats.isLoading}
        radius="md"
        onClick={() =>
          NiceModal.show(ConfirmModal, {
            title: 'Enable Real Time New Dialogs Stats?',
            onSuccess: () => enableRealtimeStats.mutate({ pageId, platform }),
          })
        }
      >
        <IconBroadcast />
      </ActionIcon>
    </Tooltip>
  );
};
